import Layout from "../../Frames/Layout"
import { useState, useEffect } from "react"
import { TextField, Stack, MenuItem} from "@mui/material"
import 'react-quill/dist/quill.snow.css';
import Toast from "../../Tools/Toast"
import { useParams, useNavigate } from "react-router-dom"
import Loader from "../../Tools/Loader";
import API from "../../../services/API/Rewards"
import FormButtons from "../../Inputs/FormButtons";
import Toggle from "../../Inputs/Toggle";
import Picture from "../../Inputs/Picture";
import CourseSelect from "../../Inputs/CourseSelect";

export default function Form(){

    const {id} = useParams()
    const [item, setItem] = useState(null)
    const [types, setTypes] = useState([])
    const [toast, setToast] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {

        if(id !== 'new'){
            API.get(id)
                .then(r => setItem(r.data))
                .catch(e => setToast(['error', "La récompense n'a pas été trouvé."]))
        }else{
            setItem({
                title: '',
                type: null,
                active: true,
                picture: null,
                course: null
            });
        }

        API.getTypes()
            .then(r => setTypes(r.data))
        

    }, [id])


    const handleSubmit = e => {
        e.preventDefault();

        if(!item.picture){
            return setToast(['error', 'Vous devez ajouter une image'])
        }
        
        (id !== 'new' ? API.put(item) : API.post(item))
            .then(r => handleSuccess(r.data))
            .catch(e => handleError())

        return setSubmitting(true);
    }


    const handleSuccess = data => {

        return API.postPicture(id !== 'new' ? id : data.id, item.picture)
            .then(r => navigate(`/marketing/rewards`))
            .catch(e => handleError(e))
    }


    const handleError = e => {
        console.log(e.response?.data)
        setToast(['error', "Une erreur s'est produite, vos modifications n'ont pas pu être enregistrées"]);
        return setSubmitting(false);
    }

    return <Layout title="Récompense" tab="rewards" menu="marketing">

        <Stack direction='row' justifyContent='center' sx={{mb: 2}}>
        
        {item && <form onSubmit={handleSubmit}>

            <Stack direction='column' width={formWidth} spacing={3}>

                <TextField 
                    label='Nom de la récompense'
                    value={item.title || ''}
                    onChange={e => setItem({...item, title: e.target.value})}
                    required
                    size='small'
                    inputProps={{maxLength: 100}}
                />

                <TextField
                    label='Type de récompense'
                    value={item.type?.id || ''}
                    onChange={e => setItem({...item, type: {id: e.target.value}})}
                    size='small'
                    select
                >
                    {types.map(t => 
                        <MenuItem value={t.id} key={t.id}>{t.title}</MenuItem>
                    )}
                </TextField>

                    
                {item.type?.id === 'course' && 
                    <CourseSelect 
                        value={item.course?.id || ''}
                        onChange={id => setItem({...item, course: {id}})}
                        required
                    />
                }

                <Picture 
                    value={item.picture}
                    onChange={file => setItem({...item, picture: file})}
                />

                <Toggle
                    label='Activer la récompense'
                    value={item.active}
                    onChange={() => setItem({...item, active: !item.active})}
                />

                <FormButtons onCancel={() => navigate(-1)} loading={submitting}/>

            </Stack>    

        </form>}

        </Stack>


        {!item && <Loader />}


        <Toast
            open={toast ? true : false} 
            severity={toast[0]} 
            duration={5000} 
            onClose={() => setToast(false)}
            message={toast[1]}
        />

    </Layout>
}

const formWidth = window.screen.width < 800 ? 350 : 600;